import { FormControl, FormHelperText, Grid, IconButton, List, ListItem, ListItemSecondaryAction, ListItemText, TextField } from '@mui/material';
import Button from '@mui/material/Button';
import { Box } from '@mui/system';
import { Link, useNavigate } from 'react-router-dom';

import { GridDeleteIcon } from '@mui/x-data-grid';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../app/store';
import configUrls from '../../../config/configUrls';
import { ProcessoAtribuir } from '../../../types/processo/ProcessoAtribuir';
import { Usuario } from '../../../types/usuario/Usuario';
import TxtUsuario from '../../autoComplete/TxtUsuario';


type Props = {
    data: ProcessoAtribuir,
    isdisabled?: boolean,
    handleSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
    handleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handletxtInteressadoChange: (value: Usuario) => void;
    interessadoValueTmp: Usuario;
  
}

export function ProcessoAtribuirForm({
    data,
    isdisabled = false,
    handleSubmit,
    handleChange,
    handletxtInteressadoChange,
    interessadoValueTmp,
   
}: Props) {

    const navigate = useNavigate();
    const { processoSelecionado } = useSelector((state: RootState) => state.processoSelecionado);



    useEffect(() => {
        if (!processoSelecionado) {
            navigate(configUrls.PROCESSO_LIST_RT);
        }
    }, [processoSelecionado, navigate]);






    return (
        <Box mt={2} p={2} >

            <form onSubmit={handleSubmit} method='POST'>

                <Grid container spacing={3}>

                    {/* U S U A R I O     I N T E R E S S A D O */}

                    <Grid item xs={12}>
                        <Box display="flex" justifyContent="space-between" gap={2}>
                            <FormControl fullWidth>
                                <TxtUsuario
                                    label="Pessoas Interessadas"
                                    value={interessadoValueTmp}
                                    handleSearchChange={(it) => {
                                        handletxtInteressadoChange(it);

                                    }}
                                />
                            </FormControl>

                           

                        </Box>                       
                    </Grid>

                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <TextField
                                id="observacoes-unidade"                               
                                label="Observação:"
                                name="observacao"
                                disabled={isdisabled}
                                onChange={handleChange}
                                size="small"
                                multiline
                                rows={4}
                                inputProps={{ maxLength: 255 }}
                                value={data.observacao}
                                placeholder="Digite aqui sua observação..."
                            />
                            <FormHelperText>
                                {data.observacao?.length}/255 caracteres
                            </FormHelperText>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                        <Box display="flex" gap={2}>

                            <Button
                                type="submit"
                                variant="contained"
                                color="secondary"
                                disabled={isdisabled}
                            >
                                Gravar
                            </Button>

                            <Button
                                variant="contained"
                                component={Link}
                                to={`${configUrls.PROCESSO_FORM_VIEW_LK}${processoSelecionado?.id}`} // Concatenando o valor de processoSelecionado
                            >
                                Voltar
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </form>
        </Box >
    )
}